import moment from 'moment';
import { apiGet } from './brainApi';

export const fetchTraccarVehicleLocations = () => {
  return apiGet(`/traccar/devices`)
    .then((devices) => {
      const deviceNames = {};
      devices.forEach((d) => {
        deviceNames[d.id] = d.name;
      });
      return deviceNames;
    })
    .then((deviceNames) => {
      return apiGet(`/traccar/positions`).then((positions) => {
        const positionData = [];
        positions.forEach((p) => {
          const positionCopy = p;
          positionCopy.name = deviceNames[p.deviceId];
          positionData.push(positionCopy);
        });
        return positionData;
      });
    });
};

export const fetchTraccarVehicleTrails = () => {
  const from = moment()
    .subtract(24, 'hours')
    .format('YYYY-MM-DDThh:mm:ssZ');
  const to = moment().format('YYYY-MM-DDThh:mm:ssZ');
  return apiGet('/traccar/route', { from, to });
};
